<template>
  <VueCookieAcceptDecline
    :element-id="elementId"
    type="bar"
    position="bottom"
    transition-name="slideFromBottom"
    @clicked-accept="handleAccept"
    @clicked-decline="handleDecline"
    @status="handleStatus"
  >
    <template #message>
      {{ messageText }}
    </template>
    <template #acceptContent>{{ acceptText }}</template>
    <template #declineContent>{{ declineText }}</template>
  </VueCookieAcceptDecline>
</template>

<script>
import VueCookieAcceptDecline from "vue-cookie-accept-decline"
import "vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css"

export default {
  name: "CookieConsent",

  components: {
    VueCookieAcceptDecline,
  },

  props: {
    elementId: {
      type: String,
      required: true,
    },
  },

  computed: {
    messageText() {
      return (
        this.$t?.("ui.cookie_consent.message") ||
        "We use cookies to ensure you get the best experience on our website."
      )
    },

    learnMoreText() {
      return this.$t?.("ui.cookie_consent.learn_more") || "Learn more"
    },

    acceptText() {
      return this.$t?.("ui.cookie_consent.accept") || "Accept"
    },

    declineText() {
      return this.$t?.("ui.cookie_consent.decline") || "Decline"
    },
  },

  methods: {
    handleAccept() {
      this.emitStatus(true);
    },
    handleDecline() {
      this.emitStatus(false);
    },
    handleStatus(status) {
      this.emitStatus(status === 'accept')
    },
    emitStatus(status){
      this.$emit('consent-status', status)
      if(status) this.$emit('consent-accepted');
      if(!status) this.$emit('consent-declined');
    }
  },
}
</script>

<style scoped>
/* Library handles all styling - we rely on its defaults */
</style>
